// Revolt Input Component
// Unified input component matching the Revolt design system
// Used throughout the application for consistent input styling

import React from 'react';
import './RevoltInput.css';

export const RevoltInput = React.forwardRef(function RevoltInput({
  children,
  variant = 'primary', // 'primary' or 'outline'
  size = 'default', // 'default' or 'sm'
  type = 'text',
  className = '',
  ...props
}, ref) {
  const inputClasses = [
    'revolt-input',
    `revolt-input-${variant}`,
    `revolt-input-${size}`,
    className
  ].filter(Boolean).join(' ');

  return (
    <input
      ref={ref}
      type={type}
      className={inputClasses}
      {...props}
    >
      {children}
    </input>
  );
});
